import React from 'react';

const All_Agent = ({ agents, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-lg">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-lg font-semibold text-green-600">Online Agents</h2>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            x
          </button>
        </div>

        {/* Display the list of online agents */}
        <div className="mt-4">
          {agents.length > 0 ? (
            agents.map((agent) => (
              <div key={agent.id} className="flex items-center gap-4 mt-2">
                <img
                  src={agent.img_url}
                  alt={agent.fullname}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h3 className="font-bold text-lg">{agent.fullname}</h3>
                  <p>🚗 Vehicle: {agent.vehicle_type.toUpperCase()}</p>
                  <p>📍 Location: {agent.location}</p>
                  <p
                    className={`font-bold ${
                      agent.status === "active" ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    🔵 Status: {agent.status}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p>No agents online</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default All_Agent;
